export default {
  field__account_number: 'Account number (IBAN)',
  field__account_holder: 'Account holder name',
  field__bank_name: 'Bank name',
  field__bank_code: 'Bank code',
  field__bank_ifsc_code: 'Bank IFSC code',
  field__account_holder_address: 'Account holder address',
  field__bank_address: 'Bank address',
  field__bic: 'BIC',
  field__purpose_of_payment: 'Payment purpose',
};
